import { useMenuStore } from '~~/stores/menu'

export default defineNuxtRouteMiddleware(async (to) => {
    const menuStore = useMenuStore()
    await menuStore.fetchMenu()

    const section = menuStore.resolveSection(to.path)

    const firstTab = section?.children?.[0] ?? null
    if (firstTab && firstTab.path !== to.path) {
        return navigateTo(firstTab.path, { replace: true })
    }
})
